import React from "react";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  QuestionCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Tooltip } from "antd";

const STATUS_STYLES = {
  approved: { bg: "#f6ffed", color: "#389e0d", border: "#b7eb8f", icon: CheckCircleOutlined },
  rejected: { bg: "#fff1f0", color: "#cf1322", border: "#ffa39e", icon: CloseCircleOutlined },
  pending: { bg: "#fff7e6", color: "#d46b08", border: "#ffd591", icon: ClockCircleOutlined },
  resubmit: { bg: "#f0f5ff", color: "#2f54eb", border: "#adc6ff", icon: SyncOutlined },
};

const DEFAULT_STYLE = {
  bg: "#fafafa",
  color: "#595959",
  border: "#d9d9d9",
  icon: QuestionCircleOutlined,
};

// `showLabel` spells out the status next to the icon instead of relying on
// a hover tooltip — used where there's room to spare (e.g. the Admin View
// status row); left off by default so table cells stay icon-only and compact.
const StatusTag = ({ status, showLabel }) => {
  const { bg, color, border, icon: Icon } = STATUS_STYLES[status] || DEFAULT_STYLE;
  const label = status
    ? status.charAt(0).toUpperCase() + status.slice(1)
    : "";

  const tag = (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: showLabel ? "0.4rem" : 0,
        height: "1.75rem",
        width: showLabel ? "auto" : "1.75rem",
        padding: showLabel ? "0 0.6rem" : 0,
        borderRadius: "4px",
        backgroundColor: bg,
        color,
        border: `1px solid ${border}`,
        fontSize: "1rem",
      }}
    >
      <Icon />
      {showLabel && (
        <span style={{ fontSize: "0.85rem", fontWeight: 600 }}>{label}</span>
      )}
    </span>
  );

  return showLabel ? tag : <Tooltip title={label}>{tag}</Tooltip>;
};

export default StatusTag;
